import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const imageUrl = (id) => (id ? `${API}/images/${id}` : null);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Normalize FastAPI/Pydantic validation errors. A 422 returns `detail` as an ARRAY of
// objects like {type, loc, msg, ...}. Components across the app do
// `toast.error(e.response.data.detail || "...")` or render it directly — passing a raw
// object/array to a toast or JSX throws React error #31 ("Objects are not valid as a React
// child") and crashes the whole app. Collapse `detail` to a readable string here so no raw
// object can ever reach the UI.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const data = error?.response?.data;
    if (data && typeof data === "object" && "detail" in data) {
      const d = data.detail;
      if (Array.isArray(d)) {
        data.detail = d
          .map((item) => (item && typeof item === "object" ? item.msg || JSON.stringify(item) : String(item)))
          .join(", ") || "Something didn't validate — please check your input.";
      } else if (d && typeof d === "object") {
        data.detail = d.msg || JSON.stringify(d);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
